/** How long a first snapshot waits for the event stream before loading without it. */
export const FIRST_SNAPSHOT_FALLBACK_MS = 4_000

type EventListen = (listener: (event: { details: unknown }) => void) => () => void

/**
 * Covers a first snapshot whose event stream never connects. A snapshot read
 * before the runtime subscribes the stream can miss changes made between the
 * two, so callers load on the stream's `server.connected` instead of at
 * startup; this loads once after `delayMs` only if that has not happened.
 * Returns a cancel.
 */
export function loadIfStreamSilent(listen: EventListen, load: () => void, delayMs = FIRST_SNAPSHOT_FALLBACK_MS) {
  let connected = false
  const stop = listen((event) => {
    if ((event.details as { type?: unknown } | null)?.type === "server.connected") connected = true
  })
  const timer = setTimeout(() => {
    stop()
    if (!connected) load()
  }, delayMs)
  return () => {
    clearTimeout(timer)
    stop()
  }
}
